import { Delete, Settings } from '@mui/icons-material';
import { styled } from '@mui/material';

export const ActivitiesWrapper = styled('div')(() => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '10px',
  background: '#fff',
  borderRadius: '8px',
  padding: '10px',
}));

export const Actions = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  height: '32px',
  gap: '8px',
}));

export const StyledSettings = styled(Settings)(({ theme }) => ({
  color: theme.palette.text.primary,
  cursor: 'pointer',
  transition: theme.transitions.create('transform'),
  '&:hover': {
    transform: 'scale(1.1)',
  },
}));

export const StyledRemove = styled(Delete)(({ theme }) => ({
  color: theme.palette.text.primary,
  cursor: 'pointer',
  transition: theme.transitions.create('transform'),
  '&:hover': {
    transform: 'scale(1.1)',
  },
}));
